export const parseExcelOption = (option) => {
  if (!option || typeof option !== "string") {
    return { id: null, name: "" };
  }
  
  const [id, name] = option.split(" - ");
  return { id: Number(id), name };
};